
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 497 497"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#455aa8"}},[_c('path',{attrs:{"d":"M197 476c0 14 6.833 21 20.5 21s20.5-7 20.5-21V282h21v194c0 14 6.833 21 20.5 21s20.5-7 20.5-21V149h10v121c0 7.334 2.5 12.667 7.5 16s10.167 3.333 15.5 0 8-8.667 8-16V145c0-14-4.667-25.5-14-34.5S305 97 289 97h-81c-15.333 0-27.833 4.333-37.5 13S156 130 156 144v127c0 6.667 2.667 11.333 8 14s10.5 2.667 15.5 0 7.5-7.334 7.5-14V149h10v327zM205 42.5c0 11.667 4.167 21.667 12.5 30s18.333 12.5 30 12.5S269 80.833 277 72.5s12-18.333 12-30-4-21.667-12-30S259.167 0 247.5 0s-21.667 4.167-30 12.5-12.5 18.333-12.5 30z"}})])])
          )
        }
      }
    